import { t } from "ttag";
import z from "zod";

import { trimmedEmail } from "@/shared/models";

export const User = z.object({
  firstName: z.string().min(1, { error: () => t`First name is required` }),
  lastName: z.string().min(1, { error: () => t`Last name is required` }),
  email: trimmedEmail,
});
export type User = z.infer<typeof User>;
